import { Button, message, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import React from "react";
import { IDocumentUploadProps } from "../type/document.types";
import { DOCUMENT_VALIDATION } from "./document-validation.constant";
import { bytesToMegaBytes } from "../../upload-document-modal/utils/document-utils";

const DocumentUploadTrigger: React.FC<IDocumentUploadProps> = (props) => {

    const validateFile = (file: File) => {
        if (!props.docType) return Upload.LIST_IGNORE;

        const config = DOCUMENT_VALIDATION[props.docType];
        if (!config) return Upload.LIST_IGNORE;

        const extension = file.name.split(".").pop()?.toLowerCase().trim() || "";

        const allowedExtensions = config.allowedTypes.map(type =>
            type.toLowerCase().trim()
        );

        if (!allowedExtensions.includes(extension)) {
            message.error(
                `Invalid file type. Allowed only: ${allowedExtensions
                    .map(type => type.toUpperCase())
                    .join(", ")}`
            );
            return Upload.LIST_IGNORE;
        }

        const fileSizeMB = bytesToMegaBytes(file.size);
        if (fileSizeMB > config.maxSizeMB) {
            message.error(`File must be smaller than ${config.maxSizeMB} MB`);
            return Upload.LIST_IGNORE;
        }

        return false;
    };

    return (
        <Upload
            multiple={false}
            beforeUpload={validateFile}
            showUploadList={false}
            disabled={props.disabled}
            onChange={(info) => props.handleDocumentUpload(info)}
            className={'pn-document__upload'}
            accept={
                props.docType
                    ? DOCUMENT_VALIDATION[props.docType]?.allowedTypes
                        .map(type => `.${type}`)
                        .join(",")
                    : ""
            }
        >

            <Button
                icon={<UploadOutlined/>}
                className={`pn-document__upload-button ${props.disabled ? 'upload-disabled' : 'upload-enabled'}`}
            >
                {props.uploadButtonText}
            </Button>
        </Upload>
    )
}

export default DocumentUploadTrigger;
